import React, { useEffect, useState } from 'react';

import CloseIcon from '@material-ui/icons/Close';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Wrapper } from './styles';
import * as actions from '../../actions';
import { useSelector } from '../../Hooks';
import { Heading } from '../Typography/Heading';

interface Props {
  color?: string;
}

const Notice: React.FC<Props> = ({ color }) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const notice = useSelector((state) => state.notice);

  const handleRequestClose = () => {
    setOpen(false);
    dispatch(actions.showNotice(''));
  };

  useEffect(() => {
    if (notice.message) {
      setOpen(true);
    }

    if (notice.autoHide) {
      setTimeout(() => {
        handleRequestClose();
      }, notice.autoHide);
    }
  }, [notice]);

  useEffect(() => {
    handleRequestClose();
  }, [history.location.pathname]);

  return open
    ? createPortal(
        <Wrapper color={color}>
          <Heading level={5} bottom={0}>
            {notice.message}
          </Heading>
          <CloseIcon onClick={handleRequestClose} />
        </Wrapper>,
        document.body,
      )
    : null;
};

export default Notice;
